import { basicAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import { domainToRegex } from "../urlPatternConversion";
import logo from "./logo.svg";

export const sncf = defineConnector({
  identifier: "sncf",
  name: "SNCF",
  tagLine: "French rail schedules, realtime, and journey planning",
  keywords: "navitia train tgv ter horaires gares",
  logo,
  protocol: "http",
  tags: ["data", "travel"],
  defaultUrlPattern: () => domainToRegex("api.sncf.com"),
  auth: (app) =>
    basicAuth({
      username: app.secret.apiToken,
      password: "",
    }),
  steps: [
    {
      title: "Request an API token",
      items: [
        {
          kind: "markdown",
          content:
            "Request a token from the [**SNCF API portal**](https://numerique.sncf.com/startup/api/). The free tier allows 150,000 requests a month, capped at 5,000 a day. The API is Navitia, so [doc.navitia.io](https://doc.navitia.io/) documents the endpoints.",
        },
      ],
    },
    {
      title: "Copy and paste the token into the field below",
      items: [
        {
          kind: "input",
          label: "API token",
          required: true,
          target: { kind: "secrets", field: "apiToken" },
          helperText:
            "Sent as the HTTP basic username with an empty password, as Navitia expects.",
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: () => "https://api.sncf.com/v1/coverage/sncf",
  },
});
